module.exports = __webpack_public_path__ + "img/spain.6066ce01.svg";